import { FileArchive, FileCode2, FileText, Link2, PlayCircle, ScrollText } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { ProductContentType, ProductCurriculumItem } from "@jipraks/shared";
import { catalogCopy } from "@client/locales/id/catalog";

const ICONS: Record<ProductContentType, LucideIcon> = {
  video: PlayCircle,
  pdf: FileText,
  json: FileCode2,
  text: ScrollText,
  zip: FileArchive,
  link: Link2,
};

export function ProductCurriculum({ items }: { items: ProductCurriculumItem[] }) {
  if (items.length === 0) return null;
  const copy = catalogCopy.detail;

  return (
    <section>
      <div className="flex items-baseline justify-between gap-4">
        <h2 className="text-xl font-semibold tracking-tight md:text-2xl">{copy.curriculumTitle}</h2>
        <span className="font-mono text-xs tracking-widest text-foreground-muted uppercase">
          {copy.curriculumCount(items.length)}
        </span>
      </div>
      <ol className="mt-5 overflow-hidden rounded-2xl border border-border-default bg-surface">
        {items.map((item, index) => {
          const Icon = ICONS[item.type];
          return (
            <li
              key={item.id}
              className="flex items-center gap-4 border-b border-border-default px-4 py-3.5 last:border-b-0 sm:px-5"
            >
              <span className="w-6 shrink-0 font-mono text-xs text-foreground-muted">
                {String(index + 1).padStart(2, "0")}
              </span>
              <Icon className="size-4 shrink-0 text-accent-bright" aria-hidden="true" />
              <span className="min-w-0 flex-1 text-sm text-foreground">{item.title}</span>
              <span className="hidden shrink-0 text-xs text-foreground-muted sm:inline">
                {catalogCopy.contentTypes[item.type]}
              </span>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
